import { render, staticRenderFns } from "./asignPtosTiendasCC.vue?vue&type=template&id=ec3ec5c8&scoped=true&"
import script from "./asignPtosTiendasCC.vue?vue&type=script&lang=js&"
export * from "./asignPtosTiendasCC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3ec5c8",
  null
  
)

export default component.exports